export default __webpack_public_path__ + "assets/dashboard-invite-a69eed786588aea6eca765dd129f8ff0.svg";